import { Component, Input } from '@angular/core';
import { FileFlatNode } from '../model/site-tree.model';

@Component({
  selector: 'app-tree-leaf-display',
  templateUrl: './tree-leaf-display.html',
  styleUrls: ['./tree-leaf-display.scss'],
  standalone: false,
})
export class SiteTreeDisplayComponent {
  @Input() node: FileFlatNode;
}
